module.exports = __webpack_public_path__ + "img/7.e7bea44e.jpg";